// Where the ChitraGupt tab in the top navigation leads.
//
// Astrologers get the workbench with its ChitraGupt panel (client picker
// first, no seeker teaser). Everyone else, and every case where the
// six-panel workbench cannot be on screen, keeps the entry screen.

// The workbench falls back to the narrow chart view under this width
// (AstrologerWorkstation), and the panel lives only in the wide layout.
export const WORKBENCH_MIN_WIDTH = 1024;

export const CHITRAGUPT_ENTRY = 'entry';
export const CHITRAGUPT_WORKBENCH_PANEL = 'workbench-panel';

export const chitraguptTabDestination = ({
  isAstrologerMode, useMobileLayout, viewportWidth, chatLocked, hasChart,
} = {}) => {
  if (!isAstrologerMode) return CHITRAGUPT_ENTRY;
  if (chatLocked) return CHITRAGUPT_ENTRY;            // a live session owns the chat view
  if (useMobileLayout) return CHITRAGUPT_ENTRY;
  if (!(Number(viewportWidth) >= WORKBENCH_MIN_WIDTH)) return CHITRAGUPT_ENTRY;
  if (!hasChart) return CHITRAGUPT_ENTRY;             // the workbench would show its empty state
  return CHITRAGUPT_WORKBENCH_PANEL;
};
